'use client'
import {useEffect, useState} from 'react'
import {FaTimes} from 'react-icons/fa'
import {Dialog, Transition} from '@headlessui/react'
import {Fragment} from 'react'
import toast from 'react-hot-toast'
import { Timer, X } from 'lucide-react';

export default function ExportGAModal({
                                          isOpen,
                                          onClose,
                                          onExport,
                                          isLoading = false,
                                          teamCount = null
                                      }: {
                                        isOpen: boolean
                                        onClose: () => void
                                        onExport: (memberCount: number) => Promise<void>
                                        isLoading?: boolean
                                        teamCount?: number | null
                                    }) {
    const [memberCount, setMemberCount] = useState<number>(teamCount ?? 0)
    useEffect(() => {
        if (teamCount !== null) {
            setMemberCount(teamCount)
        }
    }, [teamCount])
    const handleSubmit = async () => {
        if (memberCount <= 0) {
            toast.error("Vui lòng nhập số thành viên mỗi tổ lớn hơn 0")
            return
        }
        try {
            await onExport(memberCount)
            onClose()
            setMemberCount(0) // Reset form
        } catch (error) {
            console.error('Export failed:', error)
        }
    }


    return (
        <Transition appear show={isOpen} as={Fragment}>
            <Dialog as="div" className="relative z-50" onClose={onClose}>
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm"/>
                </Transition.Child>

                <div className="fixed inset-0 overflow-y-auto">
                    <div className="flex min-h-full items-center justify-center p-4 text-center">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 scale-95"
                            enterTo="opacity-100 scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 scale-100"
                            leaveTo="opacity-0 scale-95"
                        >
                            <Dialog.Panel
                                className="w-full max-w-md transform overflow-hidden rounded-xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                                <div className="flex justify-between items-center mb-4">
                                    <Dialog.Title
                                        as="h3"
                                        className="text-lg font-semibold leading-6 text-gray-900"
                                    >
                                        Xuất giáo án
                                    </Dialog.Title>
                                    <button
                                        onClick={onClose}
                                        className="text-gray-500 hover:text-gray-700 focus:outline-none"
                                    >
                                        <X/>
                                    </button>
                                </div>

                                <div className="space-y-4">
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">
                                            Số thành viên mỗi tổ
                                        </label>
                                        <input
                                            type="number"
                                            min="1"
                                            value={memberCount}
                                            onChange={(e) => setMemberCount(Number(e.target.value))}
                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                            placeholder="Nhập số thành viên"
                                        />
                                    </div>

                                    <div className="flex justify-end space-x-3 pt-4">
                                        <button
                                            onClick={onClose}
                                            className="px-4 py-2 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-500"
                                        >
                                            Hủy
                                        </button>
                                        <button
                                            onClick={handleSubmit}
                                            disabled={isLoading}
                                            className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-50"
                                        >
                                            {isLoading ? (
                                                <span className="flex items-center">
                                                    <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white"
                                                         xmlns="http://www.w3.org/2000/svg" fill="none"
                                                         viewBox="0 0 24 24">
                                                        <circle className="opacity-25" cx="12" cy="12" r="10"
                                                                stroke="currentColor" strokeWidth="4"></circle>
                                                        <path className="opacity-75" fill="currentColor"
                                                              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                                    </svg>
                                                    Đang xử lý...
                                                </span>
                                            ) : 'Xuất giáo án'}
                                        </button>
                                    </div>
                                </div>
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition>
    )
}